<div class="unauth-right-header">
  <img src="assets/images/complydome-logo.png" class="unauth-mobile-logo" alt="ComplyDome">
  <a href="https://www.complydome.com/">← Return to Website</a>
</div>

<main class="unauth-form-area">
  <div class="unauth-card">
    <h2>Sign In</h2>

    <div class="unauth-security-badge">
      <span class="unauth-security-dot"></span>
      End-to-End Encrypted
    </div>

    <div class="unauth-error-alert" *ngIf="errorMessage">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <form *ngIf="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>

      <div class="unauth-form-group"
        [class.has-error]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
        <label for="email">Email Address</label>
        <div class="unauth-input-wrapper">
          <input
            type="email"
            id="email"
            formControlName="email"
            required
            placeholder="name@practice.com"
            aria-label="Email Address">
        </div>
        <div class="unauth-error-msg" *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
          <i class="fas fa-info-circle"></i>
          <span *ngIf="loginForm.get('email')?.errors?.['required']">Email address is required.</span>
          <span *ngIf="loginForm.get('email')?.errors?.['pattern']">Please enter a valid email address.</span>
        </div>
      </div>

      <div class="unauth-form-group">
        <label for="password">Password</label>
        <div class="unauth-input-wrapper">
          <input
            type="password"
            id="password"
            formControlName="password"
            required
            placeholder="••••••••"
            aria-label="Password">
          <span
            class="unauth-toggle-password"
            (click)="togglePasswordVisibility()"
            aria-label="Toggle password visibility">
            <i id="toggle-icon" class="fas fa-eye"></i>
          </span>
        </div>
      </div>

      <button
        type="submit"
        class="unauth-btn-primary"
        [disabled]="!loginForm.valid || isLoading">
        <span class="unauth-spinner" *ngIf="isLoading"></span>
        <span *ngIf="!isLoading">Sign In</span>
      </button>

      <div class="unauth-forgot">
        <a routerLink="/forgot-password">Forgot your password?</a>
      </div>

    </form>
  </div>
</main>
